import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import api from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F6F0]">
      <Header />
      <section className="px-6 sm:px-12 lg:px-20 py-20 max-w-md mx-auto">
        <p className="label-eyebrow mb-4">Account recovery</p>
        <h1 className="font-serif text-4xl text-[#2D322B] mb-6">Forgot your password?</h1>

        {sent ? (
          <div data-testid="forgot-sent-state" className="space-y-6">
            <p className="text-base leading-relaxed text-[#5C6359]">
              If an account with <span className="text-[#2D322B]">{email}</span> exists, we&apos;ve sent a password reset link.
              The link expires in 30 minutes.
            </p>
            <p className="text-sm text-[#9A8F7E]">
              Didn&apos;t receive anything? Check your spam folder, or {" "}
              <button
                type="button"
                onClick={() => setSent(false)}
                data-testid="forgot-try-again"
                className="text-[#C05C42] hover:underline"
              >
                try again
              </button>
              .
            </p>
            <Link to="/login" data-testid="forgot-back-to-login" className="btn-primary inline-block">
              Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <p className="text-base leading-relaxed text-[#5C6359] mb-10">
              Enter the email tied to your Badi account and we&apos;ll send you a secure link to choose a new password.
            </p>
            <form onSubmit={onSubmit} className="space-y-6" data-testid="forgot-form">
              <div>
                <label className="label-eyebrow block mb-2">Email</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email"
                  className="w-full bg-transparent border-b border-[#D1C7B8] focus:border-[#C05C42] py-2 outline-none transition-colors text-[#2D322B]"
                />
              </div>
              <button type="submit" disabled={busy} data-testid="forgot-submit" className="btn-primary w-full">
                {busy ? "Sending…" : "Send reset link"}
              </button>
            </form>
            <p className="mt-8 text-sm text-[#5C6359]">
              Remembered it?{" "}
              <Link to="/login" className="text-[#C05C42] hover:underline" data-testid="forgot-link-login">
                Sign in
              </Link>
            </p>
          </>
        )}
      </section>
      <Footer />
    </div>
  );
}
